export enum MapStyle {
  Normal = 'mapbox://styles/porterbuddy/ckq0y4l310hcn18npf6yokoz0',
  Satelite = 'mapbox://styles/porterbuddy/ckr27la1yeop919n2e15vo6cb',
}
